import { render, staticRenderFns } from "./TextCarousel.vue?vue&type=template&id=2ec190ab&scoped=true"
import script from "./TextCarousel.vue?vue&type=script&lang=js"
export * from "./TextCarousel.vue?vue&type=script&lang=js"
import style0 from "./TextCarousel.vue?vue&type=style&index=0&id=2ec190ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec190ab",
  null
  
)

export default component.exports